// extracted by mini-css-extract-plugin
export var container = "Card-module--container--3DKYS";
export var card_img = "Card-module--card_img--2UpCA";
export var title = "Card-module--title--2Mg3R";
export var text = "Card-module--text--drk15";